import { buttonClass } from '@/components';
import { A } from '@solidjs/router';

const DIGITS =
  'm-0 text-[clamp(160px,min(50vw,60vh),640px)] font-black leading-[0.9] tracking-tighter';

export default function NotFound() {
  return (
    <main class="relative grid min-h-screen place-items-center overflow-hidden bg-neutral-50 p-4 dark:bg-[#0b1020]">
      <div class="notfound-flash" aria-hidden="true" />
      <div class="notfound-scanlines" aria-hidden="true" />
      <div class="notfound-shake relative z-10 text-center">
        {/* The joke: the 404 itself can't be found. It collapses like a TV switching off,
            leaves an outline where it was, and flickers back now and then. */}
        <div class="relative">
          <p class={`notfound-ghost absolute inset-0 ${DIGITS}`} aria-hidden="true">
            404
          </p>
          <p
            class={`notfound-glitch notfound-vanish ${DIGITS} text-neutral-900 dark:text-neutral-100`}
            data-text="404"
          >
            404
          </p>
        </div>
        <div class="notfound-copy">
          <h1 class="mt-4 mb-2 text-3xl font-semibold text-neutral-900 sm:text-4xl dark:text-neutral-100">
            Page not found
          </h1>
          <p class="mb-8 text-lg text-neutral-500 dark:text-neutral-400">
            We looked everywhere. Even the 404 went missing.
          </p>
          <A href="/" class={buttonClass('primary', 'lg')}>
            ← Back to home
          </A>
        </div>
      </div>
    </main>
  );
}
